<template>
    <div>
        <a @click="onMenu">
            <div class="nav-dropdown" >
                <v-icon color="primary" class="nav-icon mr-2">mdi-inbox</v-icon>
                <v-badge :content="total" :color="totalColor" :tile="true" :key="refresh">  </v-badge>
                <i class="nav-icon fas fa-caret-down" style="margin-left: 25px; font-size: 22px!important;"></i>
            </div>
        </a>
    </div>
</template>

<script>

import 'simplebar/dist/simplebar.min.css';
import Inb from "@/modules/inb/service/Inb";

const Const = {
    state: {
        notempty: "red",
    }
}

export default {
    name: "InbMessageMenu",

    props: {
        value: {
            required: true
        }
    },

    computed: {
        total() {
            return this.$store.getters.messageCount;
        },

        totalColor() {
            return this.total > 0 ? Const.state.notempty : this.$vuetify.theme.themes.light.primary;
        },

        preferences() {
            return this.$store.getters.preferences;
        },

        myCustomers () {
            return this.preferences.customer;
        },
    },

    data: () => ({
        refresh: 0
    }),

    watch: {
        value() {
            if (this.value) {
                this.load();
            }
        },

        messages () {
            this.refresh++;
        }
    },

    created() {
        this.$bus.$on(Inb.event.refresh, this.load);
        this.$bus.$on(Inb.event.attached, this.load);
    },

    beforeDestroy() {
        this.$bus.$off(Inb.event.refresh, this.load);
        this.$bus.$off(Inb.event.attached, this.load);
    },

    mounted() {
        this.load();
    },

    methods: {
        onMenu () {
            this.$emit("input", true);
        },

        load() {
            // Debounced: Inb.event.refresh can fire many times in quick succession (e.g. several
            // items changing in a batch) - collapse those into a single count refetch (HCIT-802).
            clearTimeout(this._loadTimer);
            this._loadTimer = setTimeout(() => {
                let customers = [];
                if (this.myCustomers && this.myCustomers.length > 0) {
                    customers = this.myCustomers.map(c => c.id);
                }

                this.$store.dispatch('getMessageCountByUser', { customers: customers, force: false });
            }, 250);
        },
    }
}

</script>

<style scoped>

</style>
